<template>
  <div class="accordion">
    <div
      v-for="item in content"
      :key="item.id"
      class="accordion__wrapper"
    >
      <div
        class="accordion__title"
        @click="toggleItem($event, item)"
      >
        {{ item.title }}

        <span class="accordion__button" />
      </div>
      <div
        class="accordion__content"
        v-html="item.content"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    content: {
      type: Array
    }
  },
  methods: {
    toggleItem(e, data) {
      let item = e.currentTarget
      if (!item.classList.contains('accordion__title--active')) this.$emit('getAction', data.title)
      item.classList.toggle('accordion__title--active')
    }
  }
}
</script>

<style lang="scss">
.accordion {
  font-family: 'Exo 2' !important;

  &__wrapper {
    background-color: #fff;
    margin-bottom: 8px;
    border-radius: 5px;
  }
  &__title {
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
    color: #7f1a54;
    padding: 11px 20px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &--active {
      .accordion__button {
        transform: rotate(180deg);
      }

      & + div {
        display: block;
      }
    }

    &:hover {
      .accordion__button {
        background-image: url('../../../static/images/accordion-active.svg');
      }
    }
  }

  &__button {
    width: 30px;
    height: 30px;
    background-image: url('../../../static/images/accordion-normal.svg');
    background-repeat: no-repeat;
    background-size: contain;
    transition: all ease 0.3s;
  }

  &__content {
    display: none;
    font-size: 15px;
    line-height: 22px;
    color: #303030;
    padding: 0 50px 30px 20px;
  }
}
</style>
